<template>
    <div>
        <home-header-component></home-header-component>
        <section id="hero-21" class="bg-snow hero-section division">
            <div class="container">
                <div class="row d-flex align-items-center">


                    <!-- HERO TEXT -->
                    <div class="col-md-10 offset-md-1">
                        <div class="hero-21-txt text-center">

                            <!-- Title -->
                            <h2 class="h2-lg">Creditfixrr Black Friday Sale!</h2>

                            <!-- Text -->
                            <p class="">
                                Creditfixrr.com is a <strong>DIY And Business Credit</strong> Restoration software.
                                We provide you with <strong> the Knowledge, Tools, Resources &amp; Dispute Flows
                                </strong> to help you to <strong>Improve your Credit</strong> and increase <strong>your Credit Scores</strong>.
                            </p>

                            <!-- HERO QUICK FORM -->
                            <form name="quickform" class="quick-form">

                                <!-- Form Inputs -->
                                <div>
                                    <!-- <input type="email" name="email" class="form-control email" placeholder="Your email address" autocomplete="off" required> -->
                                    <a href="/register" class="dtr-btn-flat btn-outline-secondary dtr-px-50 mr-2 ">Create Free Account</a>
                                    <a class="dtr-video-popup dtr-btn-flat btn-green dtr-px-50" data-autoplay="true" data-vbtype="video" href="/login">Login Now</a>
                                </div>

                                <!-- Form Message -->
                                <div class="quick-form-msg"><span class="loading"></span></div>

                            </form>

                            <!-- Advantages List -->
                            <ul class="advantages mt-35">
                                <li><p>{{ planStore.trialDays }} days free trial</p></li>
                                <li class="last-li"><p>Improve Your Credit Scores</p></li>
                            </ul>

                        </div>
                    </div>	<!-- END HERO TEXT -->


                </div>	   <!-- End row -->
            </div>	   <!-- End container -->
        </section>	<!-- END HERO-21 -->
        <landing-video></landing-video>
        <brands-components :statistics="landing_data"></brands-components>
        <!-- the black friday landing  -->
        <plan-component></plan-component>
        <!-- end the black friday landing  -->
        <ready-to-join-creditfixrr></ready-to-join-creditfixrr>
        <testimonial-component></testimonial-component>
        <footer-component></footer-component>
    </div>
</template>
<script>
import HomeHeaderComponent from './Home/HomeHeaderComponent.vue'
import HeaderSection from './Home/HeaderSection.vue'
import LandingVideo from './Home/LandingVideo.vue'
import BrandsComponents from './Home/BrandsComponents.vue'
import HowItWorks from './Home/HowItWorks.vue'
import StatisticsComponent from './Home/StatisticsComponent.vue'
import ReadyToJoinCreditfixrr from './Home/ReadyToJoinCreditfixrr.vue'
import PlanComponent from './Home/BlackFridayPlan.vue'
import TestimonialComponent from './Home/TestimonialComponent.vue'
import NewsLetterComponent from './Home/NewsLetterComponent.vue'
import EbooksProducts from './Home/Landing/EbooksProducts.vue'
import FooterComponent from './Home/FooterComponent.vue'
import {ref} from 'vue'
import { usePlanStore } from '../stores/PlanStore.js'
export default{
    components:{
        HomeHeaderComponent,
        HeaderSection,
        LandingVideo,
        BrandsComponents,
        HowItWorks,
        StatisticsComponent,
        ReadyToJoinCreditfixrr,
        PlanComponent,
        TestimonialComponent,
        NewsLetterComponent,
        EbooksProducts,
        FooterComponent
    },
    setup(){
        return{
            landing_data: ref({}),
            planStore: usePlanStore(),
        }
    },
    mounted(){
        let $this = this;
        const route = this.$router.resolve(
            {
                name:"landing-page"
            }
        );
        axios.post(route.href).then(({data})=>{
            if(data.error ==  false){
                $this.landing_data = data.data;
            }
        });
}
}
</script>
